import { queryOptions } from '@tanstack/react-query';

import { getInstrumentLayoutPageData } from './get-instrument-layout-page-data.ts';

interface GetInstrumentLayoutPageDataQueryOptionsInput {
	readonly ticker: string;
}

export function getInstrumentLayoutPageDataQueryOptions({ ticker }: GetInstrumentLayoutPageDataQueryOptionsInput) {
	return queryOptions({
		queryFn: () => getInstrumentLayoutPageData({ data: { ticker } }),
		queryKey: ['instrument-layout-page-data', ticker] as const,
	});
}
